import { Button } from '@gr-monorepo/common/ui';
import { Header } from 'features/shared/ui/Page';
import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ModalHeader = styled(Header)`
  padding-left: 0;
  font-weight: 700;
  font-size: 24px;
  line-height: 24px;
  text-align: center;
`;

export const ModalSubHeader = styled(Header)`
  padding-left: 0;
  font-weight: 700;
  font-size: 18px;
  line-height: 140%;
`;

export const ModalTextWrap = styled.div`
  background-color: #F4F5F6;
  padding: 24px;
  border-radius: 16px;
`;

export const ModalText = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0%;
`;

export const ButtonCopy = styled(Button)`
  padding: 11px 24px;
  width: fit-content;
  height: 46px;
  border-radius: 8px;
  &:hover {
    background-color: transparent;
    opacity: 0.8;
  }
  border: 2px solid #985eff;
  background-color: transparent;
`;

export const ModalWrap = styled.div`
  width: 720px;
  padding: 24px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 12px 24px rgba(57, 78, 127, 0.2);
  border-radius: 16px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
